/**
 * Mando UI initialisation
 */

import polyfillClosest from '../polyfill';
import navigation from 'Components/arena/navigation/mando-ui.navigation';
import cookieBanner from 'Components/arena/_cookie/mando-ui.cookie';
import accordion from 'Components/arena/accordion/mando-ui.accordion';
import gallery from 'Components/arena/gallery/mando-ui.gallery';
import videoHero from 'Components/arena/hero/mando-ui.video-hero';

document.addEventListener('DOMContentLoaded', () => {
  // Add JS helper class
  document.getElementsByTagName('html')[0].classList.remove('no-js');
  document.getElementsByTagName('html')[0].classList.add('has-js');

  //* Polyfill
  polyfillClosest();

  // Components
  navigation();
  cookieBanner();
  accordion();
  gallery();
  videoHero();
});


// WEBPACK FOOTER //
// ./src/scripts/brands/arena.js